import { useSocialLinks } from 'app/hooks/use-social-links';
import { useEffect } from 'react';
import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { TrustCircleManager } from './trust-circle-manager';
import { TrustedByMembers } from './trusted-by-members';

const TrustedMembers: NavigationScreen<'trusted-members'> = (props) => {
  const socialLinks = useSocialLinks();
  useEffect(() => {
    if (!socialLinks.isPending && !socialLinks.enabled) {
      if (props.navigation.canGoBack()) props.navigation.goBack();
      else props.navigation.navigate('main', { screen: 'billboard' });
    }
  }, [socialLinks.isPending, socialLinks.enabled, props.navigation]);
  if (!socialLinks.enabled) return null;
  return props.route.params.mode === 'circle' ? (
    <TrustCircleManager onClose={() => props.navigation.goBack()} />
  ) : (
    <TrustedByMembers {...props} />
  );
};
export const TrustedMembersScreen = withErrorBoundary(TrustedMembers);
